import React, { useMemo, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import "../styles/terminos_condiciones.css";

function ChevronIcon({ open }) {
    return (
        <svg
            className={`tc-ico tc-ico--chev ${open ? "is-open" : ""}`}
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function ShieldIcon() {
    return (
        <svg className="tc-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M12 2l8 4v6c0 5-3.4 9.7-8 10-4.6-.3-8-5-8-10V6l8-4z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M9.5 12l1.8 1.8L15 10"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function ClockIcon() {
    return (
        <svg className="tc-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M12 22A10 10 0 1 0 12 2a10 10 0 0 0 0 20z"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M12 6v6l4 2"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function TruckIcon() {
    return (
        <svg className="tc-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M3 7h11v10H3V7z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M14 10h4l3 3v4h-7v-7z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                stroke="currentColor"
                strokeWidth="2"
            />
        </svg>
    );
}

function DocIcon() {
    return (
        <svg className="tc-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M7 3h7l3 3v15H7V3z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M14 3v4h4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M9 11h6M9 15h6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}

function PillIcon() {
    return (
        <svg className="tc-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M10 14l4-4"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
            />
            <path
                d="M7.05 16.95a5 5 0 0 1 0-7.07l2.83-2.83a5 5 0 0 1 7.07 0 5 5 0 0 1 0 7.07l-2.83 2.83a5 5 0 0 1-7.07 0z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function LockIcon() {
    return (
        <svg className="tc-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M7 11V8a5 5 0 0 1 10 0v3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M6 11h12v10H6V11z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M12 15v3"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
            />
        </svg>
    );
}

function StarIcon() {
    return (
        <svg className="tc-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M12 2l3.1 6.3 7 1-5 4.9 1.2 7L12 18.8 5.7 22.2 7 15.2 2 9.3l7-1L12 2z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function InfoChip({ icon, title, text }) {
    return (
        <div className="tc-chip">
            <div className="tc-chip__icon" aria-hidden="true">{icon}</div>
            <div className="tc-chip__meta">
                <div className="tc-chip__title">{title}</div>
                <div className="tc-chip__text">{text}</div>
            </div>
        </div>
    );
}

function SectionCard({ id, num, title, subtitle, open, onToggle, children }) {
    return (
        <section id={id} className="tc-card" aria-labelledby={`${id}-title`}>
            <button className="tc-card__head" onClick={onToggle} aria-expanded={open} aria-controls={`${id}-content`}>
                <div className="tc-card__headLeft">
                    <div className="tc-badge">{num}</div>
                    <div className="tc-card__titles">
                        <h2 className="tc-card__title" id={`${id}-title`}>{title}</h2>
                        {subtitle ? <p className="tc-card__subtitle">{subtitle}</p> : null}
                    </div>
                </div>

                <div className="tc-card__headRight">
                    <span className="tc-card__anchor" aria-hidden="true">#{id}</span>
                    <ChevronIcon open={open} />
                </div>
            </button>

            <div id={`${id}-content`} className={`tc-card__content ${open ? "is-open" : ""}`}>
                {children}
            </div>
        </section>
    );
}

export default function TerminosCondiciones() {
    const sections = useMemo(
        () => [
            {
                id: "uso-app-creditos",
                num: "1",
                icon: <DocIcon />,
                title: "Uso de la App y sistema de créditos",
                subtitle: "Servicio de prepago con autogestión del usuario",
            },
            {
                id: "vigencia-caducidad",
                num: "2",
                icon: <ClockIcon />,
                title: "Vigencia y caducidad (días hábiles)",
                subtitle: "30 días hábiles para consumir el plan de 20 comidas",
            },
            {
                id: "logistica-entregas",
                num: "3",
                icon: <TruckIcon />,
                title: "Logística de entrega y “entregas fallidas”",
                subtitle: "Entrega antes de las 14:00 y protocolo de recepción",
            },
            {
                id: "cambios-direccion",
                num: "4",
                icon: <TruckIcon />,
                title: "Cambios de dirección (excepción vía WhatsApp)",
                subtitle: "La Web App no permite editar direcciones",
            },
            {
                id: "cancelaciones-devoluciones",
                num: "5",
                icon: <DocIcon />,
                title: "Política de cancelación y devoluciones",
                subtitle: "Sin reembolsos una vez iniciado el plan",
            },
            {
                id: "salud-alergenos",
                num: "6",
                icon: <PillIcon />,
                title: "Salud, alérgenos y seguridad alimentaria",
                subtitle: "Etiquetado visible + responsabilidad de verificación del cliente",
            },
            {
                id: "referidos-antifraude",
                num: "7",
                icon: <ShieldIcon />,
                title: "Política de referidos y anti-fraude",
                subtitle: "Uso legítimo de beneficios y prevención de abuso",
            },
            {
                id: "politica-privacidad",
                num: "P",
                icon: <LockIcon />,
                title: "Política de privacidad",
                subtitle: "Qué datos recopilamos, para qué y tus derechos",
            },
            {
                id: "aviso-legal",
                num: "L",
                icon: <DocIcon />,
                title: "Aviso legal",
                subtitle: "Datos identificativos del titular del servicio",
            },
            {
                id: "politica-calidad",
                num: "Q",
                icon: <StarIcon />,
                title: "Política de calidad",
                subtitle: "Transparencia, frescura, sostenibilidad y seguridad",
            },
        ],
        []
    );

    const [tocOpen, setTocOpen] = useState(false);
    const [query, setQuery] = useState("");
    const [openMap, setOpenMap] = useState(() => {
        const init = {};
        sections.forEach((s) => (init[s.id] = true));
        return init;
    });

    const filteredSections = useMemo(() => {
        const q = String(query || "").trim().toLowerCase();
        if (!q) return sections;
        return sections.filter((s) => (s.title + " " + (s.subtitle || "")).toLowerCase().includes(q));
    }, [query, sections]);

    const scrollTo = useCallback((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        setTocOpen(false);
    }, []);

    const setAll = useCallback(
        (value) => {
            const next = {};
            sections.forEach((s) => (next[s.id] = value));
            setOpenMap(next);
        },
        [sections]
    );

    return (
        <div className="tc-page">
            <div className="tc-shell">
                <header className="tc-hero">
                    <div className="tc-hero__top">
                        <div className="tc-hero__brand">
                            <div className="tc-hero__dot" aria-hidden="true" />
                            <div className="tc-hero__brandText">
                                <div className="tc-hero__brandName">TwoNutris</div>
                                <div className="tc-hero__brandSub">Web App y Servicio de Entrega</div>
                            </div>
                        </div>

                        <div className="tc-hero__actions">
                            <Link to="/login" className="tc-link">Ir a Login</Link>
                            <a className="button-primary" href="mailto:info@twonutris.net">Contacto</a>
                        </div>
                    </div>

                    <div className="tc-hero__main">
                        <h1 className="tc-hero__title">Términos y Condiciones</h1>
                        <p className="tc-hero__subtitle">
                            Versión Oficial: <strong>Diciembre 2025</strong>. Al adquirir un plan en TwoNutris, aceptas los términos que regulan el
                            uso de la plataforma, la logística de entrega y las políticas de consumo.
                        </p>

                        <div className="tc-hero__chips" role="list">
                            <InfoChip
                                icon={<DocIcon />}
                                title="Autogestión"
                                text="Tú programas tus pedidos en la App."
                            />
                            <InfoChip
                                icon={<ClockIcon />}
                                title="Caducidad"
                                text="30 días hábiles (L–V) para consumir tu plan."
                            />
                            <InfoChip
                                icon={<TruckIcon />}
                                title="Logística"
                                text="Garantía de entrega antes de las 14:00."
                            />
                            <InfoChip
                                icon={<ShieldIcon />}
                                title="Seguridad"
                                text="Reglas claras ante entrega fallida y anti-fraude."
                            />
                        </div>

                        <div className="tc-callout">
                            <div className="tc-callout__icon" aria-hidden="true">
                                <ShieldIcon />
                            </div>
                            <div className="tc-callout__text">
                                <strong>Importante:</strong> TwoNutris no envía comida automáticamente. Si no programas tus pedidos dentro de la vigencia,
                                los créditos no utilizados expiran sin reembolso.
                            </div>
                        </div>
                    </div>
                </header>

                <div className="tc-layout">
                    <aside className="tc-toc">
                        <div className="tc-toc__card">
                            <div className="tc-toc__title">Contenido</div>

                            <div className="tc-toc__search">
                                <input
                                    className="input-primary"
                                    placeholder="Buscar sección…"
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                />
                            </div>

                            <nav className="tc-toc__nav" aria-label="Tabla de contenidos">
                                {filteredSections.map((s) => (
                                    <button key={s.id} className="tc-toc__item" onClick={() => scrollTo(s.id)}>
                                        <span className="tc-toc__badge">{s.num}</span>
                                        <span className="tc-toc__text">
                                            <span className="tc-toc__textTitle">{s.title}</span>
                                            {s.subtitle ? <span className="tc-toc__textSub">{s.subtitle}</span> : null}
                                        </span>
                                    </button>
                                ))}
                            </nav>

                            <div className="tc-toc__tools">
                                <button className="tc-btn" onClick={() => setAll(true)}>Expandir todo</button>
                                <button className="tc-btn tc-btn--ghost" onClick={() => setAll(false)}>Contraer todo</button>
                            </div>

                            <div className="tc-toc__footer">
                                <div className="tc-mini">
                                    ¿Dudas? Escríbenos a <a href="mailto:info@twonutris.net">info@twonutris.net</a>
                                </div>
                            </div>
                        </div>
                    </aside>

                    <div className="tc-tocMobile">
                        <button className="tc-tocMobile__toggle" onClick={() => setTocOpen((v) => !v)} aria-expanded={tocOpen}>
                            <span>Contenido</span>
                            <ChevronIcon open={tocOpen} />
                        </button>

                        <div className={`tc-tocMobile__panel ${tocOpen ? "is-open" : ""}`}>
                            <div className="tc-tocMobile__search">
                                <input
                                    className="input-primary"
                                    placeholder="Buscar sección…"
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                />
                            </div>

                            <div className="tc-tocMobile__list" role="list">
                                {filteredSections.map((s) => (
                                    <button key={s.id} className="tc-tocMobile__item" onClick={() => scrollTo(s.id)}>
                                        <span className="tc-toc__badge">{s.num}</span>
                                        <span className="tc-tocMobile__text">{s.title}</span>
                                    </button>
                                ))}
                            </div>

                            <div className="tc-tocMobile__tools">
                                <button className="tc-btn" onClick={() => setAll(true)}>Expandir todo</button>
                                <button className="tc-btn tc-btn--ghost" onClick={() => setAll(false)}>Contraer todo</button>
                            </div>
                        </div>
                    </div>

                    <main className="tc-content">
                        <SectionCard
                            id="uso-app-creditos"
                            num="1"
                            title="Uso de la App y sistema de créditos"
                            subtitle="Nuestro servicio funciona mediante un sistema de prepago y gestión digital."
                            open={!!openMap["uso-app-creditos"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "uso-app-creditos": !p["uso-app-creditos"] }))}
                        >
                            <div className="tc-prose">
                                <ul className="tc-list">
                                    <li>
                                        <strong>Envíos disponibles:</strong> al contratar un plan, el cliente recibe <strong>20 créditos</strong> (“Envíos Disponibles”)
                                        en su perfil. Cada comida solicitada descuenta 1 crédito.
                                    </li>
                                    <li>
                                        <strong>Responsabilidad de programación:</strong> es responsabilidad exclusiva del cliente ingresar a la App y seleccionar sus menús.
                                        TwoNutris <strong>no envía comida automáticamente</strong>. Si el cliente no programa sus pedidos dentro del tiempo de vigencia,
                                        la empresa no se hace responsable por créditos no utilizados.
                                    </li>
                                    <li>
                                        <strong>Cierre de pedidos (sin excepciones):</strong> la plataforma permite ordenar o cancelar únicamente con anticipación
                                        (<strong>hasta las 23:59 del día anterior</strong>). La App bloquea cualquier solicitud para el mismo día, ya que la producción
                                        inicia de madrugada.
                                    </li>
                                </ul>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="vigencia-caducidad"
                            num="2"
                            title="Vigencia y caducidad (días hábiles)"
                            subtitle="Para ofrecer flexibilidad, manejamos un tiempo de validez superior a los días de comida contratados."
                            open={!!openMap["vigencia-caducidad"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "vigencia-caducidad": !p["vigencia-caducidad"] }))}
                        >
                            <div className="tc-prose">
                                <ul className="tc-list">
                                    <li>
                                        <strong>Regla de los 30 días hábiles:</strong> el plan de 20 comidas tiene una vigencia improrrogable de <strong>30 días hábiles</strong>
                                        (lunes a viernes) para ser consumido en su totalidad.
                                    </li>
                                    <li>
                                        <strong>Fines de semana y feriados:</strong> sábados, domingos y feriados nacionales en Ecuador <strong>no cuentan</strong> en el reloj de caducidad.
                                    </li>
                                    <li>
                                        <strong>Caducidad definitiva:</strong> al cumplirse el día hábil número 30 desde la compra, cualquier “Envío Disponible” restante
                                        expira automáticamente y se pierde. No se realizan reembolsos ni extensiones por créditos no consumidos por olvido o falta de planificación.
                                    </li>
                                </ul>

                                <div className="tc-note">
                                    <ClockIcon />
                                    <div>
                                        <strong>Sugerencia:</strong> programa tus pedidos con anticipación para evitar que tus créditos expiren.
                                    </div>
                                </div>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="logistica-entregas"
                            num="3"
                            title="Logística de entrega y “entregas fallidas”"
                            subtitle="Cobertura, horarios y protocolo de recepción."
                            open={!!openMap["logistica-entregas"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "logistica-entregas": !p["logistica-entregas"] }))}
                        >
                            <div className="tc-prose">
                                <ul className="tc-list">
                                    <li>
                                        <strong>Cobertura y costo:</strong> el transporte está incluido en el precio del plan dentro de nuestras zonas de cobertura.
                                    </li>
                                    <li>
                                        <strong>Horario de entrega (garantía 14:00):</strong> las rutas son dinámicas. Garantizamos la entrega antes de las <strong>14:00</strong>.
                                        Retrasos por fuerza mayor (cierres viales, accidentes graves, clima extremo) no serán causal de reembolso, aunque se notificará al cliente.
                                    </li>
                                    <li>
                                        <strong>Protocolo de recepción:</strong> el cliente debe asegurar que haya una persona o un lugar seguro (recepción/garita) para recibir el pedido.
                                    </li>
                                </ul>

                                <div className="tc-divider" />

                                <h3 className="tc-h3">Política de entrega fallida</h3>
                                <p>
                                    Si el motorizado llega al punto y ocurre cualquiera de los siguientes casos:
                                </p>
                                <ul className="tc-list">
                                    <li>No hay quien reciba.</li>
                                    <li>No hay recepción/garita habilitada.</li>
                                    <li>El cliente no contesta el teléfono tras 5 minutos de espera.</li>
                                </ul>
                                <p>
                                    <strong>Consecuencia:</strong> el pedido retorna a base y, por seguridad alimentaria, será desechado.
                                    El crédito de ese día se dará por consumido y no podrá recuperarse.
                                </p>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="cambios-direccion"
                            num="4"
                            title="Cambios de dirección (excepción vía WhatsApp)"
                            subtitle="La Web App no permite editar direcciones."
                            open={!!openMap["cambios-direccion"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "cambios-direccion": !p["cambios-direccion"] }))}
                        >
                            <div className="tc-prose">
                                <ul className="tc-list">
                                    <li>
                                        <strong>Notificación manual:</strong> si necesitas recibir tu comida en una ubicación diferente a la registrada,
                                        debes solicitarlo vía WhatsApp con <strong>24 horas de anticipación</strong>.
                                    </li>
                                    <li>
                                        <strong>Solicitudes de último minuto:</strong> cambios solicitados el mismo día no podrán ser procesados por logística de rutas.
                                        El pedido se entregará en la dirección original.
                                    </li>
                                </ul>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="cancelaciones-devoluciones"
                            num="5"
                            title="Política de cancelación y devoluciones"
                            subtitle="Reglas claras para mantener operación y calidad."
                            open={!!openMap["cancelaciones-devoluciones"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "cancelaciones-devoluciones": !p["cancelaciones-devoluciones"] }))}
                        >
                            <div className="tc-prose">
                                <ul className="tc-list">
                                    <li>
                                        <strong>No reembolsos:</strong> una vez iniciado el plan (consumido el primer crédito), no se realizan devoluciones
                                        parciales ni totales.
                                    </li>
                                    <li>
                                        <strong>Subjetividad gastronómica:</strong> garantizamos calidad y frescura, pero no se aceptarán devoluciones basadas en gustos
                                        personales (ej. “no me gustó el aderezo” o “tenía mucha sal para mi gusto”).
                                    </li>
                                </ul>

                                <div className="tc-divider" />

                                <h3 className="tc-h3">Cancelación de pedidos diarios</h3>
                                <ul className="tc-list">
                                    <li>
                                        <strong>Día anterior (vía App):</strong> el crédito retorna a tu saldo disponible.
                                    </li>
                                    <li>
                                        <strong>Mismo día:</strong> el crédito se descuenta y se pierde (el alimento ya fue producido).
                                    </li>
                                </ul>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="salud-alergenos"
                            num="6"
                            title="Salud, alérgenos y seguridad alimentaria"
                            subtitle="Modelo de transparencia total y autogestión del usuario."
                            open={!!openMap["salud-alergenos"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "salud-alergenos": !p["salud-alergenos"] }))}
                        >
                            <div className="tc-prose">
                                <ul className="tc-list">
                                    <li>
                                        <strong>Empaques y conservación:</strong> empaques eco-friendly aptos para microondas. Al ser comida fresca cocinada diariamente
                                        (sin conservantes industriales agresivos), es obligación del cliente refrigerar el producto inmediatamente tras la recepción.
                                        TwoNutris no responde por descomposición por mal almacenamiento.
                                    </li>
                                    <li>
                                        <strong>Información y transparencia:</strong> en cada plato, TwoNutris proporciona la lista de ingredientes en la Web App.
                                    </li>
                                    <li>
                                        <strong>Responsabilidad de verificación:</strong> TwoNutris no solicita ni almacena historiales clínicos ni listas de alergias.
                                        Por tanto, no realiza verificaciones cruzadas. Es responsabilidad exclusiva del cliente leer ingredientes antes de seleccionar y consumir.
                                    </li>
                                </ul>

                                <div className="tc-note tc-note--warn">
                                    <PillIcon />
                                    <div>
                                        <strong>Declaración de trazas:</strong> en nuestras instalaciones se procesan diariamente: gluten, lácteos, huevos, maní, nueces,
                                        soja, pescado y mariscos. Existe riesgo de contaminación cruzada (trazas).
                                    </div>
                                </div>

                                <p>
                                    <strong>Descargo de responsabilidad:</strong> TwoNutris no asume responsabilidad por reacciones alérgicas derivadas de:
                                </p>
                                <ul className="tc-list">
                                    <li>Falta de lectura de la etiqueta por parte del cliente.</li>
                                    <li>Selección voluntaria de platos con alérgenos.</li>
                                    <li>Trazas accidentales propias de una cocina comercial.</li>
                                </ul>
                                <p>
                                    El cliente con alergias severas consume los alimentos bajo su propio riesgo.
                                </p>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="referidos-antifraude"
                            num="7"
                            title="Política de referidos y anti-fraude"
                            subtitle="Reglas para un programa justo para todos."
                            open={!!openMap["referidos-antifraude"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "referidos-antifraude": !p["referidos-antifraude"] }))}
                        >
                            <div className="tc-prose">
                                <ul className="tc-list">
                                    <li>
                                        <strong>Uso de créditos:</strong> los saldos obtenidos por referidos son solo para canje en la App y no son reembolsables en efectivo.
                                    </li>
                                    <li>
                                        <strong>Anti-fraude:</strong> está prohibido crear múltiples cuentas para autoinvitarse. Si detectamos coincidencias sospechosas
                                        (IP, dirección, tarjeta), TwoNutris se reserva el derecho de cancelar créditos y suspender cuentas sin previo aviso.
                                    </li>
                                </ul>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="politica-privacidad"
                            num="P"
                            title="Política de privacidad"
                            subtitle="Cómo protegemos tus datos."
                            open={!!openMap["politica-privacidad"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "politica-privacidad": !p["politica-privacidad"] }))}
                        >
                            <div className="tc-prose">
                                <ol className="tc-ol">
                                    <li>
                                        <strong>Responsable:</strong> TwoNutris, con domicilio en Quito, Ecuador. Contacto:{" "}
                                        <a href="mailto:info@twonutris.net">info@twonutris.net</a>
                                    </li>
                                    <li>
                                        <strong>Datos que recopilamos:</strong>
                                        <ul className="tc-list">
                                            <li><strong>Identificativos:</strong> nombre, dirección, teléfono, email.</li>
                                            <li><strong>Transaccionales:</strong> historial de pedidos y pagos.</li>
                                        </ul>
                                        <div className="tc-note">
                                            <LockIcon />
                                            <div>
                                                <strong>Importante:</strong> TwoNutris no recopila ni procesa datos sensibles de salud (como alergias o historiales médicos).
                                                La gestión de restricciones alimentarias se realiza mediante lectura del etiquetado por parte del usuario.
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <strong>Finalidad:</strong> gestionar el servicio de entrega, procesar cobros y atender consultas vía WhatsApp.
                                    </li>
                                    <li>
                                        <strong>Cesión de datos:</strong> no vendemos tus datos. Solo compartimos dirección y teléfono con repartidores para la entrega
                                        y con pasarelas de pago seguras (PayPhone/PayPal) para el cobro.
                                    </li>
                                    <li>
                                        <strong>Tus derechos:</strong> puedes acceder, rectificar o eliminar tus datos solicitándolo a{" "}
                                        <a href="mailto:info@twonutris.net">info@twonutris.net</a>
                                    </li>
                                </ol>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="aviso-legal"
                            num="L"
                            title="Aviso legal"
                            subtitle="Datos del titular del servicio."
                            open={!!openMap["aviso-legal"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "aviso-legal": !p["aviso-legal"] }))}
                        >
                            <div className="tc-prose">
                                <p>En cumplimiento con la normativa vigente, se exponen los datos identificativos del titular de este servicio:</p>

                                <div className="tc-kv">
                                    <div className="tc-kv__row">
                                        <div className="tc-kv__k">Nombre Comercial</div>
                                        <div className="tc-kv__v">TwoNutris</div>
                                    </div>
                                    <div className="tc-kv__row">
                                        <div className="tc-kv__k">Razón Social</div>
                                        <div className="tc-kv__v">Camila Ponce</div>
                                    </div>
                                    <div className="tc-kv__row">
                                        <div className="tc-kv__k">RUC</div>
                                        <div className="tc-kv__v">1751880533001</div>
                                    </div>
                                    <div className="tc-kv__row">
                                        <div className="tc-kv__k">Domicilio</div>
                                        <div className="tc-kv__v">Av. Andalucía y Alfre Mena Caamaño</div>
                                    </div>
                                    <div className="tc-kv__row">
                                        <div className="tc-kv__k">Contacto</div>
                                        <div className="tc-kv__v"><a href="mailto:info@twonutris.net">info@twonutris.net</a></div>
                                    </div>
                                </div>

                                <p>
                                    El uso de la App TwoNutris implica la aceptación de nuestros Términos y Condiciones. Todos los contenidos (imágenes de platos,
                                    logotipos, textos) son propiedad intelectual de TwoNutris.
                                </p>
                            </div>
                        </SectionCard>

                        <SectionCard
                            id="politica-calidad"
                            num="Q"
                            title="Política de calidad"
                            subtitle="Compromisos del servicio TwoNutris."
                            open={!!openMap["politica-calidad"]}
                            onToggle={() => setOpenMap((p) => ({ ...p, "politica-calidad": !p["politica-calidad"] }))}
                        >
                            <div className="tc-prose">
                                <p>En TwoNutris, nos comprometemos a:</p>
                                <ul className="tc-list">
                                    <li><strong>Transparencia:</strong> etiquetar cada plato con ingredientes reales y alérgenos visibles.</li>
                                    <li><strong>Frescura:</strong> cocinar diariamente, evitando el uso de conservantes industriales.</li>
                                    <li><strong>Sostenibilidad:</strong> utilizar empaques eco-friendly que reducen el impacto ambiental.</li>
                                    <li>
                                        <strong>Seguridad:</strong> mantener estrictos protocolos de higiene en cocina, advirtiendo sobre posibilidad de trazas para
                                        proteger a clientes más sensibles.
                                    </li>
                                </ul>

                                <div className="tc-bottomCta">
                                    <div className="tc-bottomCta__left">
                                        <div className="tc-bottomCta__title">¿Necesitas ayuda o quieres reportar un incidente?</div>
                                        <div className="tc-bottomCta__text">
                                            Escríbenos y te atendemos lo antes posible.
                                        </div>
                                    </div>
                                    <div className="tc-bottomCta__right">
                                        <a className="button-primary" href="mailto:info@twonutris.net">Contactar soporte</a>
                                    </div>
                                </div>

                                <div className="tc-mini tc-mini--muted">
                                    Última actualización: Diciembre 2025.
                                </div>
                            </div>
                        </SectionCard>
                    </main>
                </div>
            </div>
        </div>
    );
}
